import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as registerState from '../reducers/register.reducer';
import * as fromRegisterState from '../auth.reducer';

import * as fromAuthReducer from '../auth.reducer';

// //#region AUTH ROOT STATE
// >(fromAuthReducer.authFeatureKey);
// //#endregion

// //#region Register SUB STATE
//   getAuthState,
// //#endregion

//#region REGISTRATION
export const getRegisterIsLoading = createSelector(fromRegisterState.getRegisterState, registerState.getIsRegisterLoading);
export const getRegistrationRequest = createSelector(fromRegisterState.getRegisterState, registerState.getRegisterRequest);
export const getRegistrationSuccess = createSelector(fromRegisterState.getRegisterState, registerState.getRegisterSuccess);
export const getRegistrationFailure = createSelector(fromRegisterState.getRegisterState, registerState.getRegisterFailure);
//#endregion
